import scheduleMaintenance from './middleware/scheduleMaintenance'
import checkAPI from './middleware/checkAPI'
import store from '../store'
import authAdmin from './middleware/authAdmin'
import authRedirect from './middleware/authRedirect'

export default [
    // Member / Provider /  Login
    {
        path: '/',
        name: 'login',
        meta: {
            title: 'Login',
            middleware: [scheduleMaintenance, checkAPI, authRedirect]
        },
        component: () => import('@/views/LoginPage.vue')
    },

    // Admin - Login
    {
        path: '/admin/login',
        name: 'adminLogin',
        meta: {
            title: 'Admin Login',
            middleware: [authAdmin, authRedirect]
        },
        component: () => import('@/components/LoginPageComp/Admin/LoginPage.vue')
    },

    // Admin - Signup
    {
        path: '/admin/register',
        name: 'adminRegister',
        meta: {
            title: 'Admin Sign Up',
            middleware: [authAdmin]
        },
        component: () => import('@/components/LoginPageComp/Admin/SignupPage.vue')
    },

    // Admin - Recover Pass
    {
        path: '/admin/recover',
        name: 'adminRecover',
        meta: {
            title: 'Admin Recover Password',
            middleware: [authAdmin]
        },
        component: () => import('@/components/LoginPageComp/ForgotPassAdmin.vue')
    },

    // Provider - Signup
    {
        path: '/signup',
        name: 'providerSignup',
        meta: {
            title: 'Provider\'s Signup'
        },
        component: () => import('@/views/providerSignup.vue')
    },

    // Provider - Recover Password
    {
        path: '/recoverPass',
        name: 'providerRecoverPass',
        meta: {
            title: 'Recover Password Provider',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/LoginPageComp/ForgotPassComp/ResetPassProvider.vue')
    },

    // Memb - Email Verification
    {
        path: '/emailverif',
        name: 'emailverif',
        meta: {
            title: 'Email Verification',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Signup/VerificationNotif.vue'),
        beforeEnter(to, from, next) {
            if (store.getters.emailModifier) {
                next()
            } else {
                next('/')
            }
        }
    },

    // Memb - Account Registered
    {
        path: '/accountRegistered',
        name: 'accountRegistered',
        meta: {
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Signup/MailConfirmed.vue'),
        beforeEnter(to, from, next) {
            let dateToday = Date.parse(new Date()) / 1000
            if (to.query.tkn > dateToday) {
                next()
            } else {
                next('/')
            }
        }
    },

    // Expired
    {
        path: '/expired',
        name: 'expired',
        meta: {
            title: 'Expired',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Signup/ActivationLinkExpired.vue'),
        beforeEnter(to, from, next) {
            let dateToday = Date.parse(new Date()) / 1000
            if (to.query.tkn < dateToday) {
                next()
            } else {
                next('/')
            }
        }
    },

    // Already Registered
    {
        path: '/registered',
        name: 'registered',
        meta: {
            title: 'Already Registered',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Signup/AlreadyRegistered.vue'),
        beforeEnter(to, from, next) {
            let dateToday = Date.parse(new Date()) / 1000
            if (to.query.tkn > dateToday) {
                next()
            } else {
                next('/')
            }
        }
    },

    // Forgot Password
    {
        path: '/forgotPass',
        name: 'forgotPass',
        meta: {
            title: 'Forgot Password',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/LoginPageComp/ForgotPass.vue')
    },

    // Verification Email Sent
    {
        path: '/resetPassNotif',
        name: 'resetPassNotif',
        meta: {
            title: 'Verification Email Sent',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Login/PassRecoveryNotif.vue'),
        beforeEnter(to, from, next) {
            if (store.getters.isRecoveryPassLinkSent) {
                next()
            } else {
                next('/')
            }
        }
    },

    // Reset Password
    {
        path: '/resetPass',
        name: 'resetPass',
        meta: {
            title: 'Reset Password',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Login/ResetPass.vue')
    },

    // Recovery Link Expired
    {
        path: '/recoveryLinkExpired',
        name: 'recoveryLinkExpired',
        meta: {
            title: 'Recovery Link Expired',
            middleware: [scheduleMaintenance, checkAPI]
        },
        component: () => import('@/components/Templates/Login/RecoveryLinkExpired.vue'),
        beforeEnter(to, from, next) {
            if (to.query.exp) {
                next()
            } else {
                next('/')
            }
        }
    }
]
